// ALL INCLUSIVE
export const offerCategoryConfig = {
  options: [
    {
      categoryName: "All Inclusive",
      headingTitle: "Oferty All Inclusive w jednym miejscu",
      layoutStyle: "grid", // Rodzaj layoutu: "grid" - kafelki z bloczkami, "rows" - 3 kolumny.
      groupsTitles: ["Najpopularniejsze", "Tanie All Inclusive", "Egzotyczne"], // Dla zakładek w przypadku użycia layoutu typu "grid" (tabs).
      colors: [],
      groups: [],
      url: "/getallinc.xml",
      pricesUrl: "/getallincceny.xml",
    },
  ],
};

// EGZOTYKA
// export const offerCategoryConfig = {
//   options: [
//     {
//       categoryName: "Egzotyka",
//       headingTitle: "Egzotyczne oferty w jednym miejscu",
//       layoutStyle: "grid", // Rodzaj layoutu: "grid" - kafelki z bloczkami, "rows" - 3 kolumny.
//       groupsTitles: [
//         "Najpopularniejsze",
//         "Wycieczki objazdowe",
//         "Tropikalne wyspy",
//         "Egzotyczne wyprawy",
//       ], // Dla zakładek w przypadku użycia layoutu typu "grid" (tabs).
//       colors: [],
//       groups: [],
//       url: "/getegzo.xml",
//       pricesUrl: "/getegzoceny.xml",
//     },
//   ],
// };

// WYCIECZKI OBJAZDOWE
// export const offerCategoryConfig = {
//   options: [
//     {
//       categoryName: "Wycieczki objazdowe",
//       headingTitle: "Oferty wycieczek objazdowych w jednym miejscu",
//       layoutStyle: "grid", // Rodzaj layoutu: "grid" - kafelki z bloczkami, "rows" - 3 kolumny.
//       groupsTitles: [
//         "Najpopularniejsze",
//         "Zwiedzamy Europę",
//         "Egzotyczne",
//         "Objazdowo-pobytowe",
//       ], // Dla zakładek w przypadku użycia layoutu typu "grid" (tabs).
//       colors: [],
//       groups: [],
//       url: "/getwyc.xml",
//       pricesUrl: "/getwycceny.xml",
//     },
//   ],
// };

// LAST MINUTE
// export const offerCategoryConfig = {
//   options: [
//     {
//       categoryName: "Last Minute",
//       headingTitle: "Oferty Last Minute ze wszystkich państw w jednym miejscu",
//       layoutStyle: "rows", // Rodzaj layoutu: "grid" - kafelki z bloczkami, "rows" - 3 kolumny.
//       groupsTitles: [], // Dla zakładek w przypadku użycia layoutu typu "grid" (tabs).
//       colors: ["orange", "blue", "green"],
//       groups: [
//         {
//           photo: "XX-grupa_lastminute-super-0001.jpg",
//           params:
//             "https://www.travelone.pl/oferta/szukaj.xml?extern=1&dojazd=samolot&dni=21&panstwo=EG,CY,MA,CI,PT,JO,TN,AE,ES,BA,GR,BG,HR,TK,IT,MG,MN&adt=2&pobyt=6,15",
//           nazwa: "Super Last Minute",
//           rodzaj: "super",
//         },
//         {
//           photo: "XX-grupa_lastminute-majowka-0001.jpg",
//           params:
//             "https://www.travelone.pl/oferta/szukaj.xml?extern=1&adt=2&pobyt=6,8&grupa=wyobj&dni=21",
//           nazwa: "Last Minute Wycieczki",
//           rodzaj: "wycieczki",
//         },
//         {
//           photo: "XX-grupa_lastminute-egzotyka-0001.jpg",
//           params:
//             "https://www.travelone.pl/oferta/szukaj.xml?extern=1&dojazd=samolot&dni=21&panstwo=KE,KR,TH,SL,IN,CV,TZ,MD,VE&adt=2&pobyt=6,15",
//           nazwa: "Egzotyczne Last Minute",
//           rodzaj: "egzotyka",
//         },
//       ],
//       url: "/getlastm.xml",
//       pricesUrl: "/getlastmceny.xml",
//     },
//   ],
// };

// FERIE ZIMOWE
// export const offerCategoryConfig = {
//   options: [
//     {
//       categoryName: "Ferie zimowe",
//       headingTitle:
//         "Oferty ferii zimowych ze wszystkich państw w jednym miejscu",
//       layoutStyle: "rows", // Rodzaj layoutu: "grid" - kafelki z bloczkami, "rows" - 3 kolumny.
//       groupsTitles: [], // Dla zakładek w przypadku użycia layoutu typu "grid" (tabs).
//       colors: ["orange", "blue", "green"],
//       groups: [
//         {
//           photo: "XX-grupa_ferie-zimowe-0001.jpg",
//           params:
//             "https://www.travelone.pl/oferta/szukaj.xml?extern=1&adt=2&pobyt=6,15&termin=2023-01-16&dni=43&panstwo=EG,CI,TN,MA,PT,CY,CV,AE",
//           nazwa: "ferie zimowe 2023",
//           rodzaj: "ferie-zimowe",
//         },
//         {
//           photo: "XX-grupa_ferie-zimowe-narty-0001.jpg",
//           params:
//             "https://www.travelone.pl/oferta/szukaj.xml?extern=1&sort=0&pobyt=7,14&udog=80000002&udor=0&adt=2&termin=2023-01-16&dni=43&noMTO=FTON",
//           nazwa: "Ferie zimowe na nartach",
//           rodzaj: "ferie-na-stoku",
//         },
//         {
//           photo: "XX-grupa_ferie-zimowe-plaza-0001.jpg",
//           params:
//             "https://www.travelone.pl/oferta/szukaj.xml?extern=1&adt=2&pobyt=6,15&termin=2023-01-16&dni=43&panstwo=KE,KR,TH,SL,VE,MD,TZ,MU,IN,CN",
//           nazwa: "Egzotyczne ferie zimowe",
//           rodzaj: "ferie-na-plazy",
//         },
//       ],
//       url: "/getferie.xml",
//       pricesUrl: "/getferieceny.xml",
//     },
//   ],
// };

// MAJÓWKA
// export const offerCategoryConfig = {
//   options: [
//     {
//       categoryName: "Majówka",
//       headingTitle: "Oferty na majówkę ze wszystkich państw w jednym miejscu",
//       layoutStyle: "rows", // Rodzaj layoutu: "grid" - kafelki z bloczkami, "rows" - 3 kolumny.
//       groupsTitles: [], // Dla zakładek w przypadku użycia layoutu typu "grid" (tabs).
//       colors: ["orange", "blue", "green"],
//       groups: [
//         {
//           photo: "XX-grupa_weekendmajowy-plaza-0001.jpg",
//           params:
//             "https://www.travelone.pl/oferta/szukaj.xml?extern=1&termin=2022-04-28&dni=5&panstwo=EG&adt=2&pobyt=6,8&dojazd=samolot",
//           nazwa: "Majówka na plaży",
//           rodzaj: "weekend-majowy",
//         },
//         {
//           photo: "XX-grupa_weekendmajowy-egzotyka-0001.jpg",
//           params:
//             "https://www.travelone.pl/oferta/szukaj.xml?extern=1&termin=2022-04-28&dni=5&panstwo=KE&adt=2&pobyt=6,8&dojazd=samolot",
//           nazwa: "Egzotyczna majówka",
//           rodzaj: "egzotyczny-weekend-majowy",
//         },
//         {
//           photo: "XX-grupa_weekendmajowy-wycieczki-objazdowe-0001.jpg",
//           params:
//             "https://www.travelone.pl/oferta/szukaj.xml?extern=1&termin=2022-04-28&dni=5&adt=2&grupa=wyobj,wjwee&noMTO=FTON",
//           nazwa: "Wycieczki objazdowe",
//           rodzaj: "wycieczki-objazdowe-weekend-majowy",
//         },
//       ],
//       url: "/getweekend.xml",
//       pricesUrl: "/getweekendceny.xml",
//     },
//   ],
// };
